import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Haptics } from '@capacitor/haptics';
import { App } from '@capacitor/app';
import {
  PushNotifications,
  PushNotificationSchema,
} from '@capacitor/push-notifications';
import { Router } from '@angular/router';
import { INotifications } from '../state-management/states/aumye-dashboard.state';
import { IClientNotifications } from './realTimeData/aumye-firebase-realtime-db.service';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationService {
  vibrationInterval: any;
  isVibrating: boolean = false;
  constructor(private _snackBar: MatSnackBar, private router: Router) {}
  async initialize() {
    await this.registerForEvents();
    await this.registerForNotifications();
    await this.registerAppOpening();
  }
  private async registerAppOpening() {
    App.addListener('appUrlOpen', (data) => {
      try {
        console.log('App opened with URL:', data.url);
        const url = new URL(data.url);

        // Extract query parameters
        const requestId = url.searchParams.get('requestId');
        const orgId = url.searchParams.get('orgId');
        const userId = url.searchParams.get('userId');
        const linkType = url.searchParams.get('linkType');
        const id = url.searchParams.get('id');
        const scrollTo = url.searchParams.get('scrollTo');
        const scrollId = url.searchParams.get('scrollId');

        // Debug log for extracted parameters
        console.log('Extracted Parameters:', {
          linkType,
          id,
          requestId,
          orgId,
          userId,
          scrollTo,
          scrollId,
        });

        // Handle different link types
        if (linkType === 'emergency') {
          this.router
            .navigateByUrl(
              `/security/emergency-respond?requestId=${requestId}&orgId=${orgId}&userId=${userId}`
            )
            .catch((err) => console.error('Navigation error:', err));
        } else if (linkType === 'incident' && id) {
          // Add scroll parameters to the navigation
          let navigationUrl = `/dashboard/view?linkType=${linkType}&id=${id}`;
          if (scrollTo) navigationUrl += `&scrollTo=${scrollTo}`;
          if (scrollId) navigationUrl += `&scrollId=${scrollId}`;

          this.router.navigateByUrl(navigationUrl).catch((err) => {
            console.error('Navigation error:', err);
          });
        } else {
          console.log('Unhandled URL type:', linkType);
          this.router
            .navigateByUrl(`/dashboard`)
            .catch((err) => console.error('Navigation error:', err));
        }
      } catch (error) {
        console.error('Error handling deep link:', error);
      }
    });
  }

  private async registerForEvents() {
    await PushNotifications.addListener('registration', (token) => {
      console.info('Registration token: ', token.value);
      localStorage.setItem('App_Token', token.value);
    });

    await PushNotifications.addListener('registrationError', (err) => {
      console.error('Registration error: ', err.error);
    });

    await PushNotifications.addListener(
      'pushNotificationReceived',
      (notification: PushNotificationSchema) => {
        console.log(
          'Push notification received: ',
          notification,
          notification.body
        );
        if (notification?.data?.notificationData) {
          try {
            const parsedNotification = JSON.parse(
              notification.data.notificationData
            );
            console.log('Parsed Notification:', parsedNotification);
            this.saveNotification(parsedNotification);
          } catch (err) {
            console.error('Failed to parse notificationData', err);
          }
        }
        const deepLink = notification.data?.deeplink;
        if (deepLink) {
          window.location.href = deepLink;
        }
        if (notification.data && notification.data.deepLink) {
          console.log(
            'Deep link found in notification: ',
            notification.data.deepLink
          );
          this.handleDeepLink(notification.data.deepLink);
        }
        if (
          notification.body.includes(
            'Alert! An Intrusion has been detected in the Organization'
          )
        ) {
          this.vibrateOnAction();
          const incidentIdStartIndex =
            notification.body.indexOf('IncidentId: ');
          if (incidentIdStartIndex !== -1) {
            // Adding the length of "IncidentId: " to get the starting index of the incident ID
            const startIndex = incidentIdStartIndex + 'IncidentId: '.length;
            // Finding the end index of the incident ID (assuming it ends with a comma)
            const endIndex = notification.body.indexOf(',', startIndex);
            if (endIndex !== -1) {
              // Extracting the incident ID using substring
              const incidentId = notification.body.substring(
                startIndex,
                endIndex
              );
              // Do something with the incident ID
              console.log('Incident ID:', incidentId);
            } else {
              console.error(
                'Comma not found after Incident ID in the notification body.'
              );
            }
          } else {
            console.error('IncidentId: not found in the notification body.');
          }
        } else {
          console.log('Not an intrusion: ', notification);
        }

        // Handle the notification data here (e.g., display an alert)
      }
    );

    await PushNotifications.addListener(
      'pushNotificationActionPerformed',
      (notification) => {
        console.log(
          'Push notification action performed',
          notification.actionId,
          notification.inputValue
        );
        const deepLink = notification.notification.data?.deeplink;
        if (deepLink) {
          window.location.href = deepLink;
        }
        if (
          notification.notification.data &&
          notification.notification.data.deepLink
        ) {
          this.handleDeepLink(notification.notification.data.deepLink);
        }
      }
    );
  }
  // Function to save a new notification
  saveNotification(message: IClientNotifications): void {
    console.log(message, 'ch4ck');

    // Get existing notifications from localStorage
    let notification: INotifications = {
      notificationOrg: message.OrgId,
      notificationTitle: message.MessageTitle,
      notificationBody: message.MessageBody,
      notificationFlowType: message.FlowType,
      notificationId: message.Id,
      notificationPeopleId: message.MessageData
        ? JSON.parse(message.MessageData)
        : [],
      notificationLink: message.MessageLink,
      timestamp: new Date(),
      read: false,
      type: 'INFO',
    };
    const existingNotifications = this.getNotificationsFromStorage();

    // Add the new notification to the array
    existingNotifications.unshift(notification);

    // Save the updated array back to localStorage
    localStorage.setItem(
      'userNotifications',
      JSON.stringify(existingNotifications)
    );
  }
  // Function to get notifications from localStorage
  getNotificationsFromStorage(): INotifications[] {
    const storedNotifications = localStorage.getItem('userNotifications');
    return storedNotifications ? JSON.parse(storedNotifications) : [];
  }
  // async vibrateOnAction() {
  //   this.openSnackBar("Intrusion Detected!!!","Snooze")
  //   try {
  //     await Haptics.vibrate({
  //       duration: 3000, // Vibration duration in milliseconds (default: 300)
  //     });
  //     setInterval(() => {
  //       console.log('im here babes ');
  //       this.vibrateOnAction();
  //     }, 6000);
  //   } catch (err) {
  //     console.error('Haptics error:', err);
  //   }
  // }
  async vibrateOnAction() {
    const isVibrate = localStorage.getItem('Vibration-Access');
    console.log(isVibrate);
    if (isVibrate) {
      this.openSnackBar('Intrusion Detected!!!', 'Snooze');
      try {
        await Haptics.vibrate({
          duration: 3000, // Vibration duration in milliseconds
        });
        this.playSound();
        this.isVibrating = true;

        this.vibrationInterval = setInterval(async () => {
          if (this.isVibrating) {
            this.playSound();
            await Haptics.vibrate({
              duration: 3000, // Vibration duration in milliseconds
            });
          }
        }, 2000);
      } catch (err) {
        console.error('Haptics error:', err);
      }
    }
  }
  openSnackBar(message: string, action: string) {
    let snackBarRef = this._snackBar.open(message, action, {
      duration: 500000, // Duration the snackbar will be visible
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
    });

    snackBarRef.onAction().subscribe(() => {
      this.stopVibration();
    });
  }
  private async playSound() {
    const audio = new Audio('assets/sound/intrusion_sos.wav'); // Add your sound file to the assets folder
    audio.play().catch((error) => {
      console.error('Error playing sound:', error);
    });
  }

  stopVibration() {
    this.isVibrating = false;
    clearInterval(this.vibrationInterval);
  }

  private async registerForNotifications() {
    const permissionStatus = await PushNotifications.checkPermissions();

    if (permissionStatus.receive === 'prompt') {
      const newStatus = await PushNotifications.requestPermissions();
      permissionStatus.receive = newStatus.receive;
    }

    if (permissionStatus.receive !== 'granted') {
      throw new Error('User denied push notification permissions.');
    }

    await PushNotifications.register();
  }

  async getDeliveredNotifications() {
    const notificationList =
      await PushNotifications.getDeliveredNotifications();
  }
  private async handleDeepLink(deepLink: string) {
    try {
      const url = new URL(deepLink);

      // Extract query parameters
      const requestId = url.searchParams.get('requestId');
      const orgId = url.searchParams.get('orgId');
      const userId = url.searchParams.get('userId');
      const linkType = url.searchParams.get('linkType');
      const id = url.searchParams.get('id');
      const scrollTo = url.searchParams.get('scrollTo'); // Extract scrollTo parameter
      const scrollId = url.searchParams.get('scrollId'); // Extract scrollId parameter

      console.log('Extracted parameters:', {
        requestId,
        orgId,
        userId,
        linkType,
        id,
        scrollTo,
        scrollId,
      });

      // Handle deep link logic based on linkType
      if (linkType === 'emergency') {
        this.router
          .navigateByUrl(
            `/security/emergency-respond?requestId=${requestId}&orgId=${orgId}&userId=${userId}`
          )
          .catch((err) => console.error('Navigation error:', err));
      } else if (linkType === 'incident' && id) {
        // Construct navigation URL with optional scrollTo and scrollId
        let navigationUrl = `/dashboard/view?linkType=${linkType}&id=${id}`;
        if (scrollTo) navigationUrl += `&scrollTo=${scrollTo}`;
        if (scrollId) navigationUrl += `&scrollId=${scrollId}`;

        this.router
          .navigateByUrl(navigationUrl)
          .catch((err) => console.error('Navigation error:', err));
      } else {
        console.log('Unhandled deep link type:', linkType);
        this.router
          .navigateByUrl(`/dashboard`)
          .catch((err) => console.error('Navigation error:', err));
      }
    } catch (error) {
      console.error('Error handling deep link:', error);
    }
  }
}
